import React from "react";
import {
  RightSidebar,
  RightSidebarHeader,
  RightSidebarContent,
  RightSidebarSaveFooter
} from "../RightSidebar";
import styles from "./OpportunitySidebar.module.scss";
import { Alert } from "@blueprintjs/core";
import { Icon } from "../../atoms/Icon";
import { useOpportunityForm } from "./OpportunitySidebarFormHooks";
import {
  useGetAvailableProducts,
  useChangeOpportunity
} from "./OpportunitySidebarHooks";
import { OpportunitySidebarForm } from "./OpportunitySidebarForm";
import ShareOpportunity from "../Share/ShareOpportunity/ShareOpportunity";
import { SubscriptionLimit } from "../SubscriptionLimit";

function OpportunitySidebar({
  filters = {},
  onDismiss,
  sidebarIsOpen = true,
  id,
  shareOpportunity
}) {
  const {
    loading: productsLoading,
    availableProducts,
    fixedFee,
    variableFee
  } = useGetAvailableProducts();

  const opportunityFormProps = useOpportunityForm();

  const {
    isAlertOpen,
    onAlertCancel,
    onAlertConfirm,
    onDismissSidebar,
    onSave,
    pageIsLoading,
    formHasAnInvalidField,
    opportunityId,
    showShare,
    setShowShare,
    isAmountInvalid
  } = useChangeOpportunity({
    onDismiss,
    opportunityFormProps,
    filters,
    productsLoading,
    id,
    shareOpportunity,
    fixedFee,
    variableFee
  });

  return (
    <>
      <Alert
        className={styles.confirmAlert}
        cancelButtonText="Cancel"
        confirmButtonText="Yes, don't save"
        icon={
          <Icon
            name="warning-sign"
            color="#7a869b"
            size={32}
            className={styles.confirmAlertIcon}
          />
        }
        intent="danger"
        isOpen={isAlertOpen}
        onCancel={onAlertCancel}
        onConfirm={onAlertConfirm}
        canEscapeKeyCancel
        canOutsideClickCancel
      >
        <p className={styles.confirmAlertMessage}>
          Are you sure you want to dismiss without saving? All your changes will
          be lost.
        </p>
      </Alert>
      <RightSidebar sidebarIsOpen={sidebarIsOpen}>
        <RightSidebarHeader
          title={
            !showShare
              ? "Create Opportunity"
              : shareOpportunity
              ? "Share"
              : "Congrats!"
          }
          onDismiss={onDismissSidebar}
          isDismissDisabled={pageIsLoading}
          className={showShare && styles.shareOpportunity}
        />

        {!showShare && (
          <>
            <RightSidebarContent>
              <SubscriptionLimit
                className={styles.opportunityAddOn}
                type="opportunities"
              />
              <OpportunitySidebarForm
                productsLoading={productsLoading}
                availableProducts={availableProducts}
                {...opportunityFormProps}
                isAmountInvalid={isAmountInvalid}
                fixedFee={fixedFee}
                variableFee={variableFee}
              ></OpportunitySidebarForm>
            </RightSidebarContent>

            <RightSidebarSaveFooter
              onCancel={onDismissSidebar}
              onSave={onSave}
              pageIsLoading={pageIsLoading}
              disableSave={formHasAnInvalidField}
            />
          </>
        )}

        {showShare && !!opportunityId && (
          <ShareOpportunity
            opportunityId={opportunityId}
            shareOpportunity={shareOpportunity}
            setShowShare={setShowShare}
            onDismiss={onDismissSidebar}
          ></ShareOpportunity>
        )}
      </RightSidebar>
    </>
  );
}

export default OpportunitySidebar;
